module.exports = __webpack_public_path__ + "img/bofangbeijing@3x.54308557.png";